import { isResource } from '@medplum/core'
import type { Questionnaire, QuestionnaireItem } from '@medplum/fhirtypes'
import { get } from 'lodash-es'
import * as definitions from '#src/models/questionnaires/definitions/index.ts'

export function isInstance(value: unknown): value is Questionnaire {
  return isResource(value) && value.resourceType === 'Questionnaire'
}

export function findByUrl(
  url: string | null | undefined
): Questionnaire | undefined {
  return Object.values(definitions)
    .filter((definition) => isInstance(definition))
    .find((definition) => get(definition, 'url') === url)
}

export function findItem(
  questionnaire: Questionnaire | null | undefined,
  linkId: string
): QuestionnaireItem | undefined {
  return findItemRecursive(questionnaire?.item, linkId)
}

function findItemRecursive(
  items: QuestionnaireItem[] | null | undefined,
  linkId: string
): QuestionnaireItem | undefined {
  if (!items) {
    return undefined
  }

  for (const item of items) {
    if (item.linkId === linkId) {
      return item
    }
    if (item.item) {
      const foundItem = findItemRecursive(item.item, linkId)
      if (foundItem) {
        return foundItem
      }
    }
  }

  return undefined
}
